export default __webpack_public_path__ + "static/media/ICS.9deba8da.jpg";